import useProject from '@hooks/useProject';
import SocialFacebookIcon from '@icons/social/SocialFacebookIcon';
import SocialHomepageIcon from '@icons/social/SocialHomepageIcon';
import SocialInstagramIcon from '@icons/social/SocialInstgramIcon';
import SocialNaverIcon from '@icons/social/SocialNaverIcon';
import SocialYoutubeIcon from '@icons/social/SocialYoutubeIcon';
import { Fragment } from 'react';

import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function OfficialChannels() {
  const project = useProject();
  const officialChannel = project?.officialChannel;
  if (officialChannel && project?.features.officialChannelEnabled) {
    const {
      homeUrl, instagramUrl, facebookUrl, youtubeUrl, naverBlogUrl,
    } = officialChannel;
    return (
          <LinkContainer title='공식채널'>
              {homeUrl && (
                  <LinkRow label='홈페이지'
                           icon={SocialHomepageIcon}
                           externalLink={homeUrl} />
              )}
            {youtubeUrl && (
                <LinkRow label='유튜브'
                         icon={SocialYoutubeIcon}
                         externalLink={youtubeUrl} />
            )}
            {instagramUrl && (
                <LinkRow label='인스타그램'
                         icon={SocialInstagramIcon}
                         externalLink={instagramUrl} />
            )}
            {naverBlogUrl && (
                <LinkRow label='네이버 블로그'
                         icon={SocialNaverIcon}
                         externalLink={naverBlogUrl} />
            )}
            {facebookUrl && (
                <LinkRow label='페이스북'
                         icon={SocialFacebookIcon}
                         externalLink={facebookUrl} />
            )}

          </LinkContainer>
    );
  }
  return (<Fragment/>);
}

export default OfficialChannels;
